<div class="list-container">
  <h1>Factures à envoyer</h1>
  <div class="invoice-container">
    <div class="toggle-wrapper">
      <div
        class="badge"
        [ngClass]="{
          'badge-error': numberInvoiceError && numberInvoiceError > 0,
          'badge-zero': !numberInvoiceError || numberInvoiceError === 0,
        }"
      >
        {{ numberInvoiceError || 0 }}
      </div>

      <app-toggle-switch
        [options]="Object.values(InvoicesStatusEnum)"
        [defaultOption]="InvoicesStatusEnum.EN_COURS"
        (currentOptionChange)="invoiceStatus($event)"
        [disabled]="isLoading"
        data-testid="invoice-toggle"
      ></app-toggle-switch>
    </div>
  </div>
  <div class="send-invoices" [ngClass]="{ 'send-invoices-inactive': invoicesStatus !== InvoicesStatusEnum.EN_COURS }">
    @if (InvoicesStatusEnum.EN_COURS === invoicesStatus) {
      <div class="text-send-invoices">
        <div class="spacement">
          <div>
            @if (invoicesNumberForSend !== 0 && invoicesValidateNumber === 0) {
              <span
                >Vous devez valider {{ invoicesNumberForSend }} facture{{ invoicesNumberForSend > 1 ? 's' : '' }} avant
                de pouvoir les envoyer.</span
              >
            }
            @if (!isSendable() && invoicesValidateNumber !== 0) {
              <span
                >Vous avez validé {{ invoicesValidateNumber }} sur {{ invoicesNumberForSend }} facture{{
                  invoicesNumberForSend > 1 ? 's' : ''
                }}.</span
              >
            }
            @if (isSendable()) {
              <span>Vous avez validé suffisamment de factures pour les envoyer.</span>
            }
          </div>
        </div>
      </div>
    }
    <div class="d-flex-row">
      @if (InvoicesStatusEnum.EN_COURS !== invoicesStatus) {
        <app-button data-testid="reset-button-in-progress" class="spacement-icon" (onclick)="refreshInvoices()">
          <app-icon
            [phosphorClass]="'ph-arrow-clockwise'"
            tooltipText="Rafraîchir"
            [tooltipPosition]="TooltipPosition.left"
          ></app-icon>
        </app-button>
      }
      <div class="buttons-actions">
        @if (InvoicesStatusEnum.EN_COURS === invoicesStatus) {
          <app-button
            (onclick)="sendAllMail()"
            [isLoading]="loaderSending"
            [isDisabled]="pageInvoices.length === 0 || !isSendable()"
          >
            <app-icon
              [phosphorClass]="'ph-envelope-simple'"
              tooltipText="Envoyer les mails"
              [tooltipPosition]="TooltipPosition.left"
            ></app-icon>
          </app-button>
        }
        <app-button
          data-testid="delete-icon"
          (onclick)="showConfirmDeleteDialog()"
          [isDisabled]="!risSelection.hasValue()"
        >
          <app-icon
            [phosphorClass]="'ph-trash'"
            tooltipText="Supprimer les factures"
            [tooltipPosition]="TooltipPosition.left"
          ></app-icon>
        </app-button>
        <app-button
          data-testid="export-button"
          [isDisabled]="isLoading"
          class="spacement-icon"
          (onclick)="exportInvoices()"
        >
          <app-icon
            [phosphorClass]="'ph-export'"
            tooltipText="Exporter les factures"
            [tooltipPosition]="TooltipPosition.left"
          ></app-icon>
        </app-button>
      </div>
    </div>
  </div>

  <div class="filter-invoices d-flex-row">
    <div class="left-filters">
      @if (InvoicesStatusEnum.ERROR !== invoicesStatus) {
        <div class="text-input-search-container">
          <input
            class="search-input"
            #inputElement
            type="text"
            placeholder="Facture, Producteur, Site, PRM, Contrat"
            [(ngModel)]="searchTerm"
            (input)="searchTerm = inputElement.value"
            (keydown.enter)="triggerSearch()"
            data-testid="search-input"
          />
          <app-icon
            class="icon-search-input"
            phosphorClass="ph-magnifying-glass"
            [size]="IconSize.medium"
            [iconStyle]="Style.bold"
          ></app-icon>
        </div>
      }
    </div>

    <app-date-range-picker
      class="date-picker"
      [label]="'Filtrer la'"
      [showFilterSelect]="true"
      (startDateChange)="onStartDateChanged($event)"
      (endDateChange)="onEndDateChanged($event)"
      (filterChange)="onFilterChanged($event)"
      [startDate]="rangeStartDate"
      [endDate]="rangeEndDate"
      [filterOptions]="filterOptions()"
      [selectedFilter]="selectedFilter"
    ></app-date-range-picker>
  </div>

  <app-server-table
    id="invoices-table"
    [tableLayoutAuto]="true"
    [pageable]="pageable"
    [isLoading]="isLoading"
    [messageInfo]="noDataMessage"
    (pageableChange)="onPageableChange($event)"
    (sortChange)="onSortChange($event)"
    (filterChange)="onColumnFiltersChange($event)"
  >
    <ng-container>
      <tr appRow *appRowHeaders></tr>
      <tr
        appRow
        class="readOnly"
        *appRowCells="let data; let i = index"
        [class.in_progress]="invoicesStatus === InvoicesStatusEnum.EN_COURS"
        [class.validated]="isStatus(data, Status.VALIDATED)"
        [class.refused]="isStatus(data, Status.REFUSED)"
      ></tr>
    </ng-container>

    <ng-container *appColumn="'checkbox'">
      <th appColumnHeader appSticky *appTableHeader>
        <app-checkbox
          id="select-all-checkbox"
          [disabled]="!pageInvoices.length || isLoading"
          (checkedChange)="masterPageToggle($event)"
          [checked]="risSelection.hasValue() && isAllPageSelected()"
          [indeterminate]="risSelection.hasValue() && isCurrentPageSelected()"
          [aria-label]="checkboxLabel()"
        ></app-checkbox>
      </th>
      <td appCell appSticky *appTableCell="let data; let i = index">
        @if (isSelectable(data)) {
          <app-checkbox
            (click)="$event.stopPropagation()"
            (checkedChange)="toggleSelection(data)"
            [checked]="risSelection.isSelected(getInvoiceKey(data))"
            [aria-label]="checkboxLabel(data?.draftNumber)"
            data-testid="checkbox"
          ></app-checkbox>
        }
      </td>
    </ng-container>

    <ng-container *appColumn="'etat'">
      <th appColumnHeader appSticky *appTableHeader [hidden]="InvoicesStatusEnum.EN_COURS !== invoicesStatus">
        <app-column-header name="État"></app-column-header>
      </th>
      <td
        appCell
        appSticky
        *appTableCell="let data; let i = index"
        [hidden]="InvoicesStatusEnum.EN_COURS !== invoicesStatus"
      >
        @if (isCheckable(data)) {
          <app-toggle-switch-check
            id="toggleState"
            [data]="data"
            [size]="ToggleSwitchSize.small"
            (selectedChange)="setSelectedValidation($event, data)"
            [selected]="data.status"
          ></app-toggle-switch-check>
        } @else {
          @if (data.status === Status.ERROR) {
            <span> Erreur </span>
          } @else {
            <span> Préfacturation </span>
          }
        }
      </td>
    </ng-container>

    <ng-container *appColumn="'dateGenerated'">
      <th appColumnHeader *appTableHeader>
        @if (InvoicesStatusEnum.ARCHIVE !== invoicesStatus) {
          <app-column-header
            name="Date de génération"
            type="sort"
            sort="desc"
            field="dateGenerated"
          ></app-column-header>
        }
      </th>
      <td data-testid="generated-date" appCell *appTableCell="let data">
        @if (InvoicesStatusEnum.ARCHIVE !== invoicesStatus) {
          <span [innerHTML]="data.dateGenerated | date: 'dd/MM/yyyy HH:mm'"></span>
        }
      </td>
    </ng-container>

    <ng-container *appColumn="'documentId'">
      <th appColumnHeader *appTableHeader>
        <app-column-header name="Facture" type="sort" field="documentId"></app-column-header>
      </th>
      <td data-testid="invoice-id" appCell *appTableCell="let data">
        <span [innerHTML]="getInvoiceId(data)"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'producer.name'">
      <th appColumnHeader *appTableHeader>
        <app-column-header name="Producteur" type="sort" field="producer.name"></app-column-header>
      </th>
      <td data-testid="producer-name" appCell *appTableCell="let data">
        <span [innerHTML]="data.producer.name"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'site.name'">
      <th appColumnHeader *appTableHeader>
        <app-column-header name="Site" type="sort" field="site.name"></app-column-header>
      </th>
      <td data-testid="site-name" appCell *appTableCell="let data">
        <span [innerHTML]="data.site.name"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'prm'">
      <th appColumnHeader *appTableHeader>
        <app-column-header name="PRM" type="sort" field="prm"></app-column-header>
      </th>
      <td data-testid="prm" appCell *appTableCell="let data">
        <span [innerHTML]="data.allPrms?.join('<br/>')"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'site.technology'">
      <th appColumnHeader *appTableHeader>
        <app-column-header name="Filière" type="sort" field="site.technology"></app-column-header>
      </th>
      <td data-testid="technology" appCell *appTableCell="let data">
        <span [innerHTML]="data.site.technology"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'DateDebutCalcul'">
      <th appColumnHeader *appTableHeader>
        <app-column-header name="Période de facturation" type="sort" field="DateDebutCalcul"></app-column-header>
      </th>
      <td data-testid="period" appCell *appTableCell="let data">
        <span [innerHTML]="getInvoicePeriod(data.DateDebutCalcul, data.DateFinCalcul)"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'sentDate'">
      <th appColumnHeader *appTableHeader>
        @if (InvoicesStatusEnum.ARCHIVE === invoicesStatus) {
          <app-column-header name="Date d'émission" type="sort" sort="desc" field="sentDate"></app-column-header>
        }
      </th>
      <td data-testid="sent-date" appCell *appTableCell="let data">
        @if (InvoicesStatusEnum.ARCHIVE === invoicesStatus) {
          <span [innerHTML]="data.sentDate | date: 'dd/MM/yyyy HH:mm'"></span>
        }
      </td>
    </ng-container>

    <ng-container *appColumn="'RES_CT.montant'">
      <th appColumnHeader *appTableHeader>
        <app-column-header name="Montant HT" type="sort" field="RES_CT.montant"></app-column-header>
      </th>
      <td data-testid="amount" appCell *appTableCell="let data">
        <p class="amount-invoices">{{ data.RES_CT?.montant | currency: 'EUR' }}</p>
        @if (data.quantity && InvoicesStatusEnum.ERROR !== invoicesStatus) {
          <p class="quantity-invoices">
            <span>{{ data.quantity | number: '1.2-2' }} MWh</span>
            <app-icon phosphorClass="ph-lightning" [size]="IconSize.small" [color]="Color.positive"></app-icon>
          </p>
        }
      </td>
    </ng-container>

    <ng-container *appColumn="'formulaLabel'">
      <th appColumnHeader *appTableHeader>
        <app-column-header
          name="Formule"
          type="filter"
          field="formulaLabel"
          [filterItems]="filterItems.formulaLabel!"
        ></app-column-header>
      </th>
      <td data-testid="formula" appCell *appTableCell="let data">
        <div class="formula-cell">
          <span>{{ formatFormulaLabel(data.formulaLabel, data.tunnelPercentage) }}</span>
          @if (data.formula === 'M0' && data.ArticleDetails[0]?.typePrix) {
            <app-badge
              [label]="mapPriceType(data.ArticleDetails[0]?.typePrix)"
              [backgroundColor]="mapPriceTypeToColor(data.ArticleDetails[0]?.typePrix)"
            >
            </app-badge>
          }
          @if (data.RES_HNEG) {
            <app-badge label="H-" [backgroundColor]="Color.danger100"> </app-badge>
          }
        </div>
      </td>
    </ng-container>

    <ng-container *appColumn="'typeBill'">
      <th appColumnHeader *appTableHeader>
        <app-column-header
          name="Type"
          type="filter"
          field="typeBill"
          [filterItems]="filterItems.typeBill!"
          [filterTranslate]="mapTypeBill"
        ></app-column-header>
      </th>
      <td data-testid="bill-type" appCell *appTableCell="let data">
        <span [innerHTML]="mapTypeBill(data.typeBill)"></span>
      </td>
    </ng-container>

    <ng-container *appColumn="'downloadButtons'">
      <th appColumnHeader appSticky="right" *appTableHeader>
        @if (InvoicesStatusEnum.ARCHIVE === invoicesStatus) {
          <app-column-header
            name="Suivi"
            type="filter"
            field="tracking"
            [filterItems]="filterItems.tracking!"
            [filterTranslate]="mapStatusTracking"
          >
          </app-column-header>
        } @else {
          <app-column-header name="Suivi"> </app-column-header>
        }
      </th>
      <td appCell appSticky="right" *appTableCell="let data; let i = index">
        <div class="actions-invoices">
          <app-button
            [style]="ButtonStyle.Outlined"
            class="comment-button"
            [size]="ButtonSize.Small"
            [class.has-comments]="data.comment"
            data-testid="comment-button"
            (onclick)="showCommentDialog(data)"
            [iconOptions]="{ phosphorClass: 'ph-chats-circle', iconStyle: Style.fill, position: ButtonIcon.OnlyIcon }"
          ></app-button>
          <app-button
            [style]="ButtonStyle.Outlined"
            [isLoading]="downloadLoaders[i!]"
            [size]="ButtonSize.Small"
            (onclick)="downloadInvoice($event, data, i!)"
            [iconOptions]="{
              phosphorClass: 'ph-download-simple',
              iconStyle: Style.bold,
              position: ButtonIcon.OnlyIcon,
            }"
            [isDisabled]="!downloadStatus.includes(data.status) || !data.documentId"
          ></app-button>
          <app-button
            [isDisabled]="
              !(
                Status.VALIDATED === data.status ||
                Status.SENT === data.status ||
                Status.ERROR_SENDING === data.status
              ) || data.contacts.length === 0
            "
            (onclick)="InvoicesStatusEnum.ARCHIVE === invoicesStatus ? openSendDialog(i!) : sendOneMail(i!)"
            [isLoading]="sendingLoaders[i!] || loaderSending"
            [style]="ButtonStyle.Outlined"
            [size]="ButtonSize.Small"
            data-testid="email-send"
            [iconOptions]="{
              phosphorClass: 'ph-envelope-simple',
              iconStyle: Style.bold,
              position: ButtonIcon.OnlyIcon,
            }"
          ></app-button>
          <div
            class="tooltip-wrapper"
            (mouseenter)="showTooltip(i!)"
            (mouseleave)="hideTooltip()"
            data-testid="sent-to"
          >
            <app-button
              [style]="ButtonStyle.Outlined"
              class="users-button"
              [size]="ButtonSize.Small"
              [iconOptions]="{
                phosphorClass: 'ph-users',
                iconStyle: Style.fill,
                position: ButtonIcon.OnlyIcon,
              }"
              [noHover]="true"
              [isDisabled]="data.contacts.length === 0"
            ></app-button>

            <app-tooltip
              [visible]="hoveredTooltipId === i && (data.contacts.length > 0 || data.failedEmailsErrorType)"
              position="left"
            >
              @if (InvoicesStatusEnum.ERROR === invoicesStatus) {
                <div>Cause de l'erreur : {{ mapTypeFailedEmailsToLibelle(data.failedEmailsErrorType) }}</div>
              }
              @if (
                InvoicesStatusEnum.ARCHIVE === invoicesStatus && toDeliveryStatusList(data.deliveryStatuses).length > 0
              ) {
                @for (deliveryStatus of toDeliveryStatusList(data.deliveryStatuses); track deliveryStatus.email) {
                  <div class="delivery-line">
                    <app-badge
                      [label]="mapDeliveryStatusLabel(deliveryStatus.status)"
                      [backgroundColor]="mapDeliveryStatusColor(deliveryStatus.status)"
                    ></app-badge>
                    <span>{{ deliveryStatus.email }}</span>
                  </div>
                }
              } @else {
                <div [innerHTML]="formatEmails(data.failedEmails || data.contacts)"></div>
              }
            </app-tooltip>
          </div>
          @if (data?.typeBill === TypeBill.DRAFT && InvoicesStatusEnum.ARCHIVE === invoicesStatus) {
            <div>
              <app-select
                [options]="statusTrackingOptions"
                [selectedValue]="data.tracking || ''"
                [isDisabled]="false"
                [size]="ButtonSize.Small"
                [style]="ButtonStyle.Outlined"
                (valueChange)="onSelectStatusChange(data, $event)"
                [getStateClass]="getSelectStateClass"
              ></app-select>
            </div>
          }
        </div>
      </td>
    </ng-container>
  </app-server-table>
</div>
